import { createContext, useContext } from 'react'

import { ZoomableItem } from './types.js'

export interface MediaZoomContext {
  zoomEnabled: boolean
  zoomed: boolean
  activeIndex: number
  register: (item: ZoomableItem) => void
  unregister: (id: string) => void
  openItem: (id: string) => void
  toggle: () => void
}

export const MediaZoomContext = createContext<MediaZoomContext>(undefined)

export const useMediaZoomContext = () => {
  const context = useContext(MediaZoomContext)
  if (context === undefined) {
    throw new Error('useMediaZoom must be used within a MediaZoomProvider')
  }
  return context
}
